// extracted by mini-css-extract-plugin
export default {"playersContainer":"playersContainer-kf0nWvKr","playerWrapper":"playerWrapper-jSWROWpE","avatar":"avatar-HwYTgC6K","statusIcon":"statusIcon-nb9VgeeJ"};